import { makeStyles } from 'tss-react/mui';
export default makeStyles()(() => ({
    MessageWrapper: {
        wordBreak: 'break-word',
    },
    TitleAndActionLabelWrapper: {
        display: 'flex',
        justifyContent: 'space-between',
    }
}));
//# sourceMappingURL=styles.js.map